import React, { useEffect } from 'react'
import { Table, Button, Row, Col } from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'
import {
  listCategories,
  deleteCategory,
} from '../../../actions/categoryActions'

const CategoryAdmin = ({ history }) => {
  const dispatch = useDispatch()
  const categoryList = useSelector((state) => state.categoryList)
  const {
    loading: categoriesLoading,
    categories,
  } = categoryList

  const deleteACategory = useSelector((state) => state.deleteACategory)
  const {
    loading: loadingDelete,
    success: successDelete,
  } = deleteACategory

  function deleteCategoryHandler(pId, name) {
    if (window.confirm(`Delete "${name}"?`)) {
      dispatch(deleteCategory(pId))
    }
  }

  useEffect(() => {
    dispatch(listCategories())
  }, [successDelete])

  return (
    <section>
      <div className='container'>
        <Row className='align-items-center my-5'>
          <Col>
            <h4>Categories ({categories?.length || 0})</h4>
          </Col>
          <Col className='text-end'>
            <a href='/admin/category/create'>
              <Button className='my-3 btnCommon'>
                <i className='fas fa-plus'></i> Create a Category
              </Button>
            </a>
          </Col>
        </Row>

        {loadingDelete && <p className="text-muted">Deleting...</p>}

        {categoriesLoading ? (
          <p>Loading categories...</p>
        ) : (
          <Table bordered hover responsive className='table-sm'>
            <thead className='table-light'>
              <tr>
                <th style={{ width: 40 }}>#</th>
                <th>Name</th>
                <th>Slug</th>
                <th style={{ width: 110 }}>Products</th>
                <th style={{ width: 100 }}>Homepage</th>
                <th style={{ width: 160 }}>Actions</th>
              </tr>
            </thead>
            <tbody>
              {categories?.map((category, i) => (
                <tr key={category._id}>
                  <td>{i + 1}</td>
                  <td><strong>{category.name}</strong></td>
                  <td className='text-muted'>{category.slug}</td>
                  <td>
                    <span className='badge bg-light text-dark border'>
                      {category.productCount ?? 0}
                    </span>
                  </td>
                  <td>
                    {category.showOnHomepage ? (
                      <span className='badge bg-success'>Active</span>
                    ) : (
                      <span className='badge bg-secondary'>No</span>
                    )}
                  </td>
                  <td>
                    <div className='d-flex gap-1'>
                      <Button
                        variant='outline-secondary'
                        className='btn-sm'
                        onClick={() => history.push(`/admin/category/edit/${category.slug}`)}
                      >
                        <i className='fas fa-edit'></i> Edit
                      </Button>
                      <Button
                        variant='outline-danger'
                        className='btn-sm'
                        onClick={() => deleteCategoryHandler(category._id, category.name)}
                      >
                        <i className='fas fa-trash'></i>
                      </Button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        )}
      </div>
    </section>
  )
}

export default CategoryAdmin
